import { render } from "./InviteLinkConfirmPopup.vue?vue&type=template&id=66538ee2&ts=true"
import script from "./InviteLinkConfirmPopup.vue?vue&type=script&lang=ts"
export * from "./InviteLinkConfirmPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__